import React, { useState, useEffect } from 'react'
import '../../../styles/feedsAndDashboard/TaskFeed.css'

const ProgressBarAnalytics = ({ height = 12, completed, frontColor = '#6FCC8799', restColor = '#FC4C5999', addDots = false, dotsPercentage = 1 }) => {
    const [currentCompleted, setCurrentCompleted] = useState(completed)

    useEffect(() => {
        setCurrentCompleted(completed)
    }, [completed])

    return (
        <div className="w-full flex flex-row rounded-full m-0  relative overflow-hidden" style={{ height: height }}>
            <div
                style={{
                    width: `${Math.min(currentCompleted, 100)}%`,
                    backgroundColor: frontColor,
                    height: height,
                    transition: 'width 400ms ease-in-out',
                }}
                className="rounded-l-full"
            ></div>
            <div
                style={{
                    width: `${Math.min(100 - currentCompleted, 100)}%`,
                    backgroundColor: restColor,
                    height: height,
                    transition: 'width 400ms ease-in-out',
                }}
                className="rounded-r-full"
            ></div>
            {addDots && (
                <>
                    <div
                        style={{
                            width: 1,
                            height: height * 1.4,
                            transition: 'left 400ms ease-in-out',
                            position: 'absolute',
                            left: `${dotsPercentage * 100}%`,
                            borderLeft: '1.5px dashed #413F5E',
                            top: -height * 0.2,
                        }}
                    />
                    <p
                        className="text-[14px] font-semibold text-[#413F5E] absolute px-[5px] cursor-default transition-[left] duration-[400ms] ease-in-out"
                        style={{ left: dotsPercentage < 0.95 ? `${dotsPercentage * 100}%` : 'unset', right: 0 }}
                    >
                        {Math.round(dotsPercentage * 100)}%
                    </p>
                </>
            )}
        </div>
    )
}

export default ProgressBarAnalytics
